import { request } from '../client';

export const getAppConfig = () => request('/config', { auth: false });

export const getServiceablePincodes = () => request('/serviceable-pincodes');

export const getDeliverySlots = () => request('/delivery-slots');

export const getPaymentSettings = () => request('/settings/payment');

export const getPolicies = () => request('/policies');
